module.exports = __webpack_public_path__ + "c667b7bfc37b709d484cdaad23f503a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Round.png
// module id = 784
// module chunks = 0